module.exports = __webpack_public_path__ + "media/assets/icons/external-link-outline-1e43f59d571d66e8f015d03c11e0838f.svg";